// extracted by mini-css-extract-plugin
export default {"icon":"DXw_0","img":"YS7nI"};